import { render, staticRenderFns } from "./ChecklistsChecklistDescription.vue?vue&type=template&id=7becbd38&scoped=true"
import script from "./ChecklistsChecklistDescription.vue?vue&type=script&lang=js"
export * from "./ChecklistsChecklistDescription.vue?vue&type=script&lang=js"
import style0 from "./ChecklistsChecklistDescription.vue?vue&type=style&index=0&id=7becbd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7becbd38",
  null
  
)

export default component.exports